<template>
  <div class="page-wrapper">
    <div class="tableBox">
      <el-table v-loading="isLoading" :data="tableData">
        <el-table-column label="序号" width="50" type="index">
        </el-table-column>
        <el-table-column label="活动ID">
          <template slot-scope="scope">
            {{scope.row.activityId}}
          </template>
        </el-table-column>
        <el-table-column label="照片">
          <template slot-scope="scope">
            <el-image
              style="width: 40px; height: 40px; background: #efefef;"
              fit="cover"
              :src="scope.row.photoUrl" 
              :preview-src-list="srcList"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column label="姓名">
          <template slot-scope="scope">
            {{scope.row.name || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="手机号">
          <template slot-scope="scope">
            {{scope.row.phoneNumber || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="当前职位">
          <template slot-scope="scope">
            {{scope.row.currentPosition || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="意向职位">
          <template slot-scope="scope">
            {{scope.row.intentionPosition || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="签到时间">
          <template slot-scope="scope">
            {{scope.row.createTime || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="备注">
          <template slot-scope="scope">
            {{scope.row.remark || '-'}}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pageBox">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pagination.current"
        :page-size.sync="pagination.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        background
      >
      </el-pagination>
    </div>

  </div>
</template>

<script>
import { utils } from "@/common/common.js";
import { api, request } from "@/common/request_course.js";
import { buildThumborUrl } from '@/common/tool.js'
export default {
  name: "checkinList",
  data() {
    return {
      isLoading: false,
      pagination: {
        current: 1,
        size: 10,
        total: 0,
      },
      //表格
      tableData: [],
      // 图片列表
      srcList: [],
      
    };
  },
  computed: {
    adminId() {
      return utils.getAdminId();
    },
    token() {
      return utils.getToken();
    },
  },
  watch: {
    $route: {
      handler: function (route) {
        let query = route.query
        this.pagination.size = Number(query.size)
          ? Number(query.size)
          : 10;
        this.pagination.current = Number(query.current)
          ? Number(query.current)
          : 1;
        this.getCheckinList();
      },
      immediate: true,
    },
  },
  methods: {
    getCheckinList() {
      this.isLoading = true;
      let params =  {
        current: this.pagination.current,
        size: this.pagination.size,
      }
      request({
        url: api.baseUrl + "/course-checkin/pageList",
        method: "get",
        params
      })
      .then((res) => {
        console.log(res);
        if (res.erroyCode == 200) {
          this.pagination.total = parseInt(res.data.total);
          let srcList = []
          this.tableData = res.data.records.map(item => {
            let photoUrl = item.photoPath ? buildThumborUrl(item.photoPath) : undefined
            if (photoUrl) {
              srcList.push(photoUrl)
            }
            return {
              ...item,
              photoUrl 
            }
          })
          this.srcList = srcList
        } else {
          this.$message.error(res.errorMsg || "网络错误");
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.isLoading = false;
      });
    },
    updateRouter() {
      let str = "?current=" +
        this.pagination.current +
        "&size=" +
        this.pagination.size
      str += '&r=' + new Date().getTime()
      this.$router.push(
        "/checkin/list" + str
      );
    },
    handleSizeChange(size) {
      //分页：每页n条
      this.pagination.size = size;
      this.pagination.current = 1;
      this.updateRouter();
    },
    handleCurrentChange(current) {
      //分页：改变第n页
      this.pagination.current = current;
      this.updateRouter();
    },
  },
};
</script>

<style scoped lang="scss">
.page-wrapper {
  background: #fff;
  padding: 16px;
  margin: 10px;
}
.tableBox {
  padding: 16px 0;
}
>>> .image-slot {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
}

</style>



// WEBPACK FOOTER //
// src/pages/checkin/list.vue